import React, {
  useState, useContext, useEffect, useRef,
} from 'react';
import moment from 'moment';
import qs from 'qs';
import { DatePicker, Input as AntdInput, Modal } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import './AddStudentContainer.scss';
import axios from 'axios';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import Page from './Page';
import FooterWithButton from '../components/footerWithButton';
import SelectField from '../components/forms/selectField';
import UserContext from '../contexts/userContext';
import statusEnum from '../enums/status.enum';
import { getHebBirthDate } from '../utils/dates';
import Button from '../foundation/Button';
import Input from '../foundation/Input';

const { TextArea } = AntdInput;

const selectActiveStatusOpts = [
  { value: statusEnum.active, text: 'פעיל' },
  { value: statusEnum.notActive, text: 'לא פעיל' },
];

const defaultValues = {
  status: statusEnum.active,
};

function AddStudent() {
  // support edit mode
  const { studentId } = useParams();
  const history = useHistory();
  const user = useContext(UserContext);
  const [student, setStudent] = useState(null);
  const [parashot, setParashot] = useState([]);
  const [nusach, setNusach] = useState(0);
  const [error, setError] = useState(null);

  function validate() {
    let err;
    if (!student) {
      err = 'יש להזין שם תלמיד';
      setError(err);
      return false;
    }

    if (!student.name) err = 'יש להזין שם תלמיד';
    else if (!student.lastName) err = 'יש להזין שם משפחה';
    // if (!student.motherName) err = 'יש להזין את שם האם';
    // if (!student.fatherName) err = 'יש להזין את שם האב';
    else if (!student.parentPhone) err = 'יש להזין טלפון של ההורה';
    else if (!student.parasha1) err = 'יש לבחור פרשה ראשונה';
    // if (!student.parasha2) err = 'יש לבחור פרשה שנייה';
    else if (!student.birthDate) err = 'יש לבחור תאריך לידה';
    else if ((Date.now() - (new Date(student.birthDate)).getTime()) / (1000 * 60 * 60 * 24 * 365) < 11) err = 'התלמיד מתחת לגיל 11';
    // if (!student.haftara) err = 'יש לבחור הפטרה';
    else if (!student.phoneNumber) err = 'יש להזין טלפון';
    else if (!/^\d{7,15}$/.test(sanitizePhone(student.phoneNumber))) err = 'מספר הטלפון של הילד אינו תקין';
    else if (student.parentPhone && !/^\d{7,15}$/.test(sanitizePhone(student.parentPhone))) err = 'מספר הטלפון של ההורה אינו תקין';

    // create fields validation
    else if (!studentId) {
      if (!student.password || !student.passwordConfirm) err = 'יש להזין סיסמא';
      else if (student.password !== student.passwordConfirm) err = 'הסיסמאות אינן זהות';
    }

    if (err) {
      setError(err);
      return false;
    }
    return true;
  }

  const isMounted = useRef(true);

  useEffect(() => () => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    const getStudent = async () => {
      const studentRes = await axios.get(`/api/users/${studentId}?deleted=true`);
      setStudent(studentRes.data);
      setNusach(parseInt(studentRes.data.nusach, 10));
    };
    if (studentId) getStudent();
  }, [studentId]);

  useEffect(() => {
    const getParashot = async () => {
      const parsahotRes = await axios.get('/api/parashot');
      if (!parsahotRes?.data || !Array.isArray(parsahotRes.data)) {
        return;
      }

      setParashot(parsahotRes.data.map((p) => ({
        text: p.name,
        value: p.parashaId,
        bookId: p.bookId,
      })));
    };
    getParashot();
  }, []);

  const [submitDisabled, setSubmitDisabled] = React.useState(false);

  async function submitStudent() {
    setSubmitDisabled(true);
    const queryString = qs.parse(history.location.search, { ignoreQueryPrefix: true });
    const queryGuideId = queryString?.guideId;

    try {
      await axios.post('/api/users', {
        ...student,
        guideId: user.isGuide ? user.userId : (queryGuideId || student.guideId),
        isStudent: true,
        nusach,
        status: student.status ?? statusEnum.active,
        phoneNumber: sanitizePhone(student.phoneNumber),
        parentPhone: sanitizePhone(student.parentPhone || ''),
        phone: sanitizePhone(student.phoneNumber),
      });
      if (history.location.search || user.isGuide) history.push(`/admin/guide${history.location.search}`);
      else history.push('/admin/manager/students');
    } catch (err) {
      if (err.response.status === 409) setError('משתמש כבר קיים. בחר מספר טלפון אחר.');
      else setError('אירעה שגיאה');
    }

    if (isMounted) {
      setSubmitDisabled(false);
    }
  }

  async function handleAddClick() {
    if (!validate()) return;

    // On new student creation, require explicit confirmation (incl. billing consent).
    if (!studentId) {
      Modal.confirm({
        title: 'אישור פתיחת כרטיס תלמיד',
        content: (
          <>
            <div>בדקתי את כל פרטי הילד והם נכונים.</div>
            <div>אני מאשר לחייב את חשבוני בסך של 15 ש&quot;ח.</div>
            <div className="mandatory-warning">
              ⚠ שים לב: שם פרטי, שם משפחה, טלפון ותאריך לידה לא ניתנים
              לשינוי לאחר יצירת התלמיד.
            </div>
          </>
        ),
        okText: 'אישור',
        cancelText: 'ביטול',
        onOk: () => submitStudent(),
      });
      return;
    }

    await submitStudent();
  }

  const phoneFields = ['phoneNumber', 'parentPhone'];

  function sanitizePhone(value) {
    return value.replace(/[^0-9]/g, '').trim();
  }

  function handleChange(event) {
    if (event.target.name === 'status') {
      setStudent({
        ...student,
        status: selectActiveStatusOpts[event.target.selectedIndex - 1].value,
      });
    } else {
      const value = phoneFields.includes(event.target.name)
        ? sanitizePhone(event.target.value)
        : event.target.value;
      setStudent({
        ...student,
        [event.target.name]: value,
      });
    }
  }

  function renderDate() {
    if (!student?.birthDate) return '';
    return (
      <span className="hebrew-date">
        תאריך עברי:
        {' '}
        {getHebBirthDate(student.birthDate, student.afterSunset)}
      </span>
    );
  }
  if (studentId && !student) return '';

  // Identity fields (first name, last name, phone, birth date) can only be
  // edited by a manager. A guide may set them when creating a student, but once the
  // student exists (edit mode) these fields are locked for guides — only an admin can change them.
  // Parasha may be edited by a guide; changes are logged on the server.
  const disableMandatoryFields = !!studentId && !user?.isManager;

  let defaultStatusValue = defaultValues.status;
  if (student) {
    defaultStatusValue = (student.status === null || student.status === undefined)
      ? statusEnum.notActive : student.status;
  }

  return (
    <Page title={studentId ? 'עריכת תלמיד' : 'הוספת תלמיד'} showBackBtn>
      <div className="add-student-container">
        <div className="add-guide-form">
          <br />
          {disableMandatoryFields && (
            <div className="form-info">
              שדות הזיהוי המסומנים ב-
              <span className="required-mark">*</span>
              {' '}
              (שם פרטי, שם משפחה, טלפון ותאריך לידה) ניתנים לעריכה על ידי מנהל בלבד.
            </div>
          )}
          {!studentId && !user?.isManager && (
            <div className="form-info">
              שדות החובה מסומנים ב-
              <span className="required-mark">*</span>
              . שים לב: לאחר יצירת התלמיד לא ניתן לשנות שם פרטי, שם משפחה, טלפון ותאריך לידה, אלא על ידי מנהל בלבד.
            </div>
          )}
          <div className="stars-wrapper">
            <SelectField
              text="סטאטוס"
              options={selectActiveStatusOpts}
              name="status"
              defaultValue={defaultStatusValue.toString()}
              placeholder="סטטוס"
              onChange={handleChange}
            />
            <Input
              className="input-field"
              name="stars"
              type="number"
              min={0}
              max={999}
              autoComplete="off"
              onChange={handleChange}
              placeholder="כוכבים"
              value={student?.stars}
            />
            <div>
              <Button
                onClick={(ev) => setStudent({
                  ...student,
                  stars: (parseInt(student?.stars, 10) || 0) + 5,
                })}
                square
                small
              >
                <span>+5</span>

              </Button>
              <Button
                onClick={(ev) => setStudent({
                  ...student,
                  stars: (parseInt(student?.stars, 10) || 0) + 10,
                })}
                square
                small
              >
                <span>+10</span>

              </Button>
              <Button
                onClick={(ev) => setStudent({
                  ...student,
                  stars: (parseInt(student?.stars, 10) || 0) + 20,
                })}
                square
                small
              >
                <span>+20</span>

              </Button>
            </div>
          </div>
          <div>
            <Input
              className="input-field"
              name="name"
              autoComplete="off"
              onChange={handleChange}
              placeholder="שם פרטי"
              required
              disabled={disableMandatoryFields}
              value={student?.name}
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="lastName"
              autoComplete="off"
              onChange={handleChange}
              value={student?.lastName}
              required
              disabled={disableMandatoryFields}
              placeholder="שם משפחה"
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="motherName"
              autoComplete="off"
              onChange={handleChange}
              value={student?.motherName}
              placeholder="שם האם"
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="fatherName"
              autoComplete="off"
              onChange={handleChange}
              value={student?.fatherName}
              placeholder="שם האב"
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="parentPhone"
              autoComplete="off"
              value={student?.parentPhone}
              onChange={handleChange}
              placeholder="טלפון של הורה"
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="phoneNumber"
              autoComplete="off"
              value={student?.phoneNumber}
              onChange={handleChange}
              placeholder="טלפון של הילד"
              required
              disabled={disableMandatoryFields}
            />
          </div>
          <div>
            <Input
              className="input-field"
              name="address"
              autoComplete="off"
              value={student?.address}
              onChange={handleChange}
              placeholder="כתובת מגורים"
              disabled={disableMandatoryFields}
            />
          </div>
          <>
            <div>
              <Input
                className="input-field"
                name="password"
                type="password"
                onChange={handleChange}
                placeholder="סיסמא"
                autoComplete="new-password"
              />
            </div>
            <div>
              <Input
                className="input-field"
                name="passwordConfirm"
                type="password"
                autoComplete="new-password"
                onChange={handleChange}
                placeholder="אימות סיסמא"
              />
            </div>
          </>
          <SelectField
            text="פרשה ראשונה"
            options={parashot}
            name="parasha1"
            value={parashot?.find((i) => i.value === parseInt(student?.parasha1, 10))?.value}
            placeholder="בחר פרשה ראשונה"
            required={!studentId}
            onChange={(ev) => {
              setStudent({
                ...student,
                [ev.target.name]: parashot[ev.target.selectedIndex - 1].value,
              });
            }}
          />
          <br />
          <SelectField
            text="פרשה שנייה"
            options={parashot}
            name="parasha2"
            value={parashot?.find((i) => i.value === parseInt(student?.parasha2, 10))?.value}
            placeholder="בחר פרשה שנייה"
            onChange={(ev) => setStudent({
              ...student,
              [ev.target.name]: parashot[ev.target.selectedIndex - 1].value,
            })}
          />
          <br />
          <div>
            <SelectField
              text="הפטרה"
              options={parashot.filter((p) => p.bookId <= 5)}
              name="haftara"
              value={parashot?.find((i) => i.value === parseInt(student?.haftara, 10))?.value}
              placeholder="בחר הפטרה"
              onChange={(ev) => setStudent({
                ...student,
                [ev.target.name]: parashot[ev.target.selectedIndex - 1].value,
              })}
            />
          </div>
          <br />
          <div className="select-buttons-wrapper">
            <div className="nusah-lbl"><span>נוסח הקריאה</span></div>
            <div className="select-buttons">
              <button type="button" onClick={() => setNusach(0)} className={`select-button${nusach === 0 ? ' selected' : ''}`}>
                <span>ספרדי מרוקאי</span>
              </button>
              <button type="button" onClick={() => setNusach(1)} className={`select-button${nusach === 1 ? ' selected' : ''}`}>
                <span>אשכנזי</span>
              </button>
              <button type="button" onClick={() => setNusach(2)} className={`select-button${nusach === 2 ? ' selected' : ''}`}>
                <span>ספרדי ירושלמי</span>
              </button>
            </div>
          </div>
          <br />
          <div className="birth-date">
            <div className="nusah-lbl">
              בחר תאריך לידה
              <span className="required-mark">*</span>
            </div>
            <DatePicker
              name="birthDate"
              disabled={disableMandatoryFields}
              allowClear={false}
              className="date-picker"
              label="בחר תאריך לידה"
              placeholder="תאריך לידה"
              value={moment(student?.birthDate)}
              onChange={(date) => setStudent({ ...student, birthDate: date })}
            />
            <Checkbox
              checked={student?.afterSunset}
              name="afterSunset"
              onChange={(ev) => setStudent({ ...student, afterSunset: ev.target.checked })}
            >
              אחרי השקיעה
            </Checkbox>
            <br />
            {renderDate()}
          </div>
          <br />
          <div className="textarea-field">
            <TextArea
              value={student?.comment}
              onChange={handleChange}
              rows={4}
              placeholder="הערה"
              name="comment"
            />
          </div>
          <br />
        </div>
        <br />
        <FooterWithButton disabled={submitDisabled} btnText={studentId ? 'שמור' : 'הוסף'} btnClick={handleAddClick}>
          {error && (
            <div className="form-error">
              <span>{error}</span>
            </div>
          )}
        </FooterWithButton>
      </div>
    </Page>

  );
}

export default AddStudent;
